import { render, staticRenderFns } from "./JobRequests.vue?vue&type=template&id=5d5c4158&"
import script from "./JobRequests.vue?vue&type=script&lang=js&"
export * from "./JobRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports